import { Injectable } from '@angular/core';

import { NOT_APPLICABLE, TrackData, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

@Injectable({
    providedIn: 'root',
})
export class RewardTokenCardTrackingService {
    baseTrackingDetails: { [key: string]: string };
    constructor(private trackingService: TrackingService) {}

    trackCardInfoLinkClick(tokenType: string, tokenTitle: string | undefined, tokenUrl: string, baseTracking: { [key: string]: string }): void {
        this.baseTrackingDetails = baseTracking;
        const trackingData: TrackData = {
            ...this.getBaseTrackingData(),
            [trackingConstants.COMPONENT_ACTION_EVENT]: TrackingValues.Click,
            [trackingConstants.COMPONENT_POSITION_EVENT]: tokenType,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: tokenTitle,
            [trackingConstants.COMPONENT_URL_CLICKED]: tokenUrl,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: TrackingValues.BetRewardbanner,
        };
        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    rewardTokenCardPopUpTrackingService(tokenType: string | undefined): void {
        const trackingData: TrackData = {
            ...this.getBaseTrackingData(),
            [trackingConstants.COMPONENT_ACTION_EVENT]: TrackingValues.Load,
            [trackingConstants.COMPONENT_POSITION_EVENT]: tokenType,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: TrackingValues.RewardDetailsOverlay,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: TrackingValues.RewardDetailsOverlay,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        };
        this.trackingService.track(trackingConstants.EVENT_CONTENT_VIEW, trackingData);
    }

    trackCardDetails(tokenType: string, viewDetailsTitle: string | undefined, tokenInfoUrl: string): void {
        const trackingData: TrackData = {
            ...this.getBaseTrackingData(),
            [trackingConstants.COMPONENT_ACTION_EVENT]: TrackingValues.Click,
            [trackingConstants.COMPONENT_POSITION_EVENT]: tokenType,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: viewDetailsTitle,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: TrackingValues.RewardDetailsOverlay,
            [trackingConstants.COMPONENT_URL_CLICKED]: tokenInfoUrl,
        };
        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    getBaseTrackingData(): TrackData {
        return {
            ...this.baseTrackingDetails,
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: TrackingValues.PromoHub,
            [trackingConstants.COMPONENT_LABEL_EVENT]: TrackingValues.BetRewardbanner,
            [trackingConstants.COMPONENT_MODULE_SOURCE]: TrackingValues.StandardModule,
        };
    }
}

export enum TrackingValues {
    PromoHub = 'promo hub',
    BetRewardbanner = 'bet rewards banner',
    Click = 'click',
    StandardModule = 'standard module',
    Load = 'load',
    RewardDetailsOverlay = 'reward details overlay',
}
